// extracted by css-extract-rspack-plugin
var _1 = "QDzdp1FU4Z480BCT";
var _2 = "SrP36Wwqsnc1LQjh";
var _3 = "nv3uqGdGGygvEQwQ";
var _4 = "hIq_ZTRs_ygJ2Or8";
export { _1 as "iconPosition", _2 as "iconPositionAlways", _3 as "iconPositionDesktop", _4 as "iconPositionRight" }
// extracted by css-extract-rspack-plugin
var _1 = "QDzdp1FU4Z480BCT";
var _2 = "SrP36Wwqsnc1LQjh";
var _3 = "nv3uqGdGGygvEQwQ";
var _4 = "hIq_ZTRs_ygJ2Or8";
export { _1 as "iconPosition", _2 as "iconPositionAlways", _3 as "iconPositionDesktop", _4 as "iconPositionRight" }
